const LISTVIEW_TYPES = {
  compressedList: 'compressedList',
  list: 'list',
  grid: 'grid',
};

export default LISTVIEW_TYPES;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/listViewTypes.js